import t from 'ember-intl/helpers/t';
import RouteTemplate from 'ember-route-template';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const GroupInviteShowExceededComponent = <template>
  <div class="flex items-center flex-col content-center justify-center h-full">
    <div class="mb-8" data-test-svg-container>
      {{svgJar "error-link-capacity" width="342" height="257"}}
    </div>

    <h1 class="text-2xl font-bold mb-1 text-center text-grey-darkest" data-test-error-title>
      {{t "group_invite.error_capacity_title"}}
    </h1>

    <p class="text-base text-center text-grey-darkest max-w-md leading-relaxed" data-test-contact-host-message>
      {{t "group_invite.error_contact_your_host"}}
    </p>
  </div>
</template>;

export default RouteTemplate(GroupInviteShowExceededComponent);
